import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import Button from '@mui/material/Button';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Helper from '../pages/Helper';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ModeEditIcon from '@mui/icons-material/ModeEdit';

  export default function Row(props){
   
    const {key,row,parentrow,handleDelete,handleEdit,params,index} = props;
   // console.log(parentrow)
    const [open, setOpen] = React.useState(false);
 
    return (
      <React.Fragment>
        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
          <TableCell>
            {row.length > 0  && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
            )}
          </TableCell>
         
          <TableCell align="right"  sx={{fontSize:12}}>{index + 1}</TableCell>
          <TableCell  sx={{fontSize:12}}>
                        {(params.toUpperCase()=="ADD" || params.toUpperCase()=="EDIT") && (
                        <Button
                            onClick={() => handleDelete(parentrow.id)} // Pass the project ID to the edit function
                        >
                        <DeleteForeverIcon  sx={{ fontSize: 20 }}/>
                        </Button>
                        )}

                        {(params.toUpperCase()=="ADD" || params.toUpperCase()=="EDIT") && (
                        <Button
                            onClick={() => handleEdit(parentrow)} // Pass the project ID to the edit function
                        >
                        <ModeEditIcon  sx={{ fontSize: 20 }}/>
                        </Button>
                        )}
                    </TableCell>
                    <TableCell align="right"  sx={{fontSize:12}}>{parentrow.part_no}</TableCell>
                    <TableCell align="right"  sx={{fontSize:12}}>{parentrow.descriptions}</TableCell>
                    <TableCell align="right"  sx={{fontSize:12}}>{parentrow.qty}</TableCell>
                    <TableCell align="right"  sx={{fontSize:12}}>{parentrow.unitname}</TableCell>
                    <TableCell align="right"  sx={{fontSize:12}}>{Helper.formatAsCurrency(parentrow.price)}</TableCell>
                    <TableCell align="right"  sx={{fontSize:12}}>{Helper.formatAsCurrency(parentrow.total)}</TableCell>
                    <TableCell align="right"  sx={{fontSize:12}}>{Helper.formatAsCurrency(parentrow.hpp)}</TableCell>
                    <TableCell align="right"  sx={{fontSize:12}}>{Helper.formatAsCurrency(parentrow.hpp_total)}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <Box sx={{ margin: 1 }}>
                                <Typography variant="h6" gutterBottom component="div">
                                    SUB ITEMS
                                </Typography>
                            <Table size="medium" aria-label="purchases" sx={{width:"100%"}}>
                            <TableHead>
                            <TableRow>
                    
                                <TableCell  sx={{fontSize:12}}>Part No</TableCell>
                                <TableCell  sx={{fontSize:12}}>Descriptions</TableCell>
                                <TableCell  sx={{fontSize:12}}>Qty</TableCell>
                                <TableCell  sx={{fontSize:12}}>Unit</TableCell>
                                <TableCell align="right"  sx={{fontSize:12}}>Price</TableCell>
                                <TableCell align="right"  sx={{fontSize:12}}>Total</TableCell>
                                <TableCell align="right"  sx={{fontSize:12}}>Other Cost</TableCell>
                                <TableCell align="right"  sx={{fontSize:12}}>HPP</TableCell>
                                <TableCell align="right"  sx={{fontSize:12}}>HPP TOTAL</TableCell>
                            </TableRow>
                        </TableHead>
                    <TableBody>
                    {row.map((historyRow) => (
                      <TableRow key={historyRow.part_no} width="100%">
                        <TableCell  sx={{fontSize:12, width:300}} component="th" scope="row">
                          {historyRow.part_no}
                        </TableCell>
                        <TableCell  sx={{fontSize:12, width:300}}>{historyRow.descriptions}</TableCell>
                        <TableCell align="right"  sx={{fontSize:12}}>{historyRow.qty}</TableCell>
                        <TableCell align="right"  sx={{fontSize:12}}>
                        {historyRow.unitname}
                        </TableCell>
                        <TableCell align="right"  sx={{fontSize:12}}>{Helper.formatAsCurrency(historyRow.price)}</TableCell>
                        <TableCell align="right"  sx={{fontSize:12}}>{Helper.formatAsCurrency(historyRow.total)}</TableCell>
                        <TableCell align="right"  sx={{fontSize:12}}>{Helper.formatAsCurrency(historyRow.other_cost)}</TableCell>
                        <TableCell align="right"  sx={{fontSize:12}}>{Helper.formatAsCurrency(historyRow.hpp)}</TableCell>
                        <TableCell align="right"  sx={{fontSize:12}}>{Helper.formatAsCurrency(historyRow.hpp_total)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }
  
//   Row.propTypes = {
//     row: PropTypes.shape({
//       calories: PropTypes.number.isRequired,
//       carbs: PropTypes.number.isRequired,
//       fat: PropTypes.number.isRequired,
//       history: PropTypes.arrayOf(
//         PropTypes.shape({
//           amount: PropTypes.number.isRequired,
//           customerId: PropTypes.string.isRequired,
//           date: PropTypes.string.isRequired,
//         }),
//       ).isRequired,
//       name: PropTypes.string.isRequired,
//       price: PropTypes.number.isRequired,
//       protein: PropTypes.number.isRequired,
//     }).isRequired,
//   };

 // export default Row